import { mapGetters } from 'vuex';

import Contract from '@/models/contract';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import { isMarketSingle, isContractOpen } from '@/utils/helpers';

export default {
  components: {
    marketChangePrice,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    contract: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    contractModel() {
      return new Contract(this.contract);
    },
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    title() {
      if (!this.isMarketSingle) return this.contractModel.contractName || this.contractModel.name;
      return this.contract.noContract ? 'No' : 'Yes';
    },
    price() {
      const lastPrice = this.contractModel.lastTradePriceAsCentsWithZeroBypass;
      if (!this.isMarketSingle) return lastPrice;
      if (this.contract.noContract) {
        return (lastPrice === 0) ? 0 : (100 - lastPrice);
      }
      return (lastPrice === 0) ? 0 : lastPrice;
    },
    changePrice() {
      const price = this.contractModel.changePriceAsCents;
      return this.contract.noContract ? -price : price;
    },
    classModifiers() {
      return {
        'market-contract-v2': true,
      };
    },
    isDisabled() {
      return !isContractOpen(this.contractModel);
    },
    contractRoute() {
      const query = { contractId: this.contract.contractId }
      if (this.contract.noContract) {
        query.no = 'true';
      }
      return {
        name: 'market-details',
        params: { marketId: this.market.marketId },
        query
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/market-contract-v2/market-contract-v2.js